import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLoader } from "./LoaderContext";
import { useSiteConfig } from "./SiteConfigContext";

// Loader ka markup public/index.html wale pre-React loader jaisa hi hai
// (same classes), isliye React mount hone par koi jump/flicker nahi dikhta.
const getCachedLogo = () => {
  try {
    const raw = sessionStorage.getItem("site_config");
    return raw ? JSON.parse(raw)?.data?.logo || "" : "";
  } catch (e) {
    return "";
  }
};

export const LoaderView = ({ hiding = false }) => {
  const logo = getCachedLogo();
  return (
    <div
      className={`app-loader${hiding ? " app-loader--hide" : ""}`}
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className="app-loader__box">
        <div className="app-loader__ring" />
        {logo && <img className="app-loader__logo" src={logo} alt="" />}
      </div>
    </div>
  );
};

// Page ke andar chhota loader (header/footer ke beech), full-screen nahi
export const InlineLoader = () => (
  <div
    style={{
      minHeight: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
    role="status"
    aria-label="Loading"
  >
    <div className="app-loader__box" style={{ width: 56, height: 56 }}>
      <div className="app-loader__ring" />
    </div>
  </div>
);

// Suspense fallback (lazy components ke liye)
const PageLoader = () => <LoaderView />;

// Website khulte hi: jab tak site config + (home page par) home data nahi aata,
// tab tak full-screen loader. Isse static header/footer ka flicker nahi dikhta.
const MAX_WAIT = 8000; // network atak jaye to bhi site khul jaye
const FADE_MS = 350;

export const InitialLoader = () => {
  const { pathname } = useLocation();
  const { homeReady } = useLoader();
  const { configReady } = useSiteConfig();

  const [phase, setPhase] = useState("show"); // show -> hide -> gone
  const timedOut = useRef(false);
  const [, force] = useState(0);

  const ready = configReady && (pathname !== "/" || homeReady);

  useEffect(() => {
    const t = setTimeout(() => {
      timedOut.current = true;
      force((n) => n + 1);
    }, MAX_WAIT);
    return () => clearTimeout(t);
  }, []);

  const done = ready || timedOut.current;

  useEffect(() => {
    if (done && phase === "show") setPhase("hide");
  }, [done, phase]);

  useEffect(() => {
    if (phase !== "hide") return;
    const t = setTimeout(() => setPhase("gone"), FADE_MS);
    return () => clearTimeout(t);
  }, [phase]);

  // loader dikh raha ho to background scroll band
  useEffect(() => {
    if (phase === "gone") return;
    document.documentElement.classList.add("app-loading");
    return () => document.documentElement.classList.remove("app-loading");
  }, [phase]);

  if (phase === "gone") return null;
  return <LoaderView hiding={phase === "hide"} />;
};

export default PageLoader;
